import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Row, Col, Container, Alert } from 'reactstrap';
// import { LinkContainer } from 'react-router-bootstrap';
// Local Deps
import './BidMatchSettings.scss';
import msgs from '../../config/messages';
// HOC
import BidMatchSettingsHOC from './BidMatchSettingsHOC';
// Components
import NotificationCard from '../NotificationCard';
import Loading from '../Loading';
// import { accountAdminRoute } from '../../config/navigation/routes';
// import NFButton from '../primitives/NFButton';

class BidMatchSettings extends Component {
  static propTypes = {
    notificationCards: PropTypes.arrayOf(
      PropTypes.shape({
        filterGroups: PropTypes.array.isRequired,
        selectedFilters: PropTypes.object.isRequired,
        minimumQuantity: PropTypes.number.isRequired,
        minimumEstimatedCost: PropTypes.number.isRequired,
      }),
    ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    onInputChange: PropTypes.func.isRequired,
    // onAddCardClick: PropTypes.func.isRequired,
    uiMessage: PropTypes.shape({
      message: PropTypes.string,
      type: PropTypes.string,
    }).isRequired,
    altupdateSettings: PropTypes.func,
  };

  static defaultProps = {
    altupdateSettings: null
  };

  static _generateCards(notificationCards, onInputChange, altupdateSettings) {
    return notificationCards.map((card, idx) => (
      <Col sm={12} key={card.id || `card-${idx}`}>
        {/* <!-- CARD --> */}
        <NotificationCard
          cardIndex={idx}
          {...card}
          onInputChange={onInputChange}
          altupdateSettings={altupdateSettings}
        />
      </Col>
    ));
  }

  render() {
    const {
      notificationCards,
      isLoading,
      onInputChange,
      altupdateSettings,
      uiMessage,
    } = this.props;
    return (
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - BidMatchSettings Page</title>
        </Helmet>
        <div className="bid-match-header">
          <h1>Bid Match Settings Management</h1>
          <p>Manage your bid matching preferences by selecting from the options below.</p>
        </div>
        <div className="nf-notifications">
          {/* <!-- SUBHEADER --> */}
          <h4 className="nf-notifications__subheader">
            {msgs.BidMatchSettings.subheader}
          </h4>
          <Alert color="info">
            * NOTE Changes to your bid match settings are saved automatically.
          </Alert>
          {/* <!-- LOADING --> */}
          {isLoading && <Loading />}
          {/* <!-- CONTENT --> */}
          {!isLoading && (
            <div className="nf-notifications__content">
              {/* <!-- CARDS --> */}
              <Row>
                {BidMatchSettings._generateCards(
                  notificationCards,
                  onInputChange,
                  altupdateSettings,
                )}
              </Row>
              {uiMessage.message && (
                <Alert color={uiMessage.type}>{uiMessage.message}</Alert>
              )}
              {/* <!-- NO CARDS FOUND MESSAGE --> */}
              <div className="nf-notifications__message">
                {isEmpty(notificationCards) && msgs.BidMatchSettings.noCardsFound}
              </div>
            </div>
          )}
        </div>
      </Container>
    );
  }
}

export default BidMatchSettingsHOC(BidMatchSettings);



// WEBPACK FOOTER //
// ./src/components/BidMatchSettings/BidMatchSettings.jsx